<template>
<svg width="18" height="9" viewBox="0 0 99 49" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M48 37.5L55 44.5L94.5 5" stroke="#B3C2FE" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4 24L24 44L64 4" stroke="#FA8643" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>